import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faHome, 
  faShoppingBag, 
  faSearch, 
  faArrowLeft,
  faExclamationTriangle
} from '@fortawesome/free-solid-svg-icons';

const NotFoundPage: React.FC = () => {
  return (
    <div className="pt-20 min-h-screen flex items-center justify-center bg-gradient-to-br from-[#2b603e] via-[#1a4a2a] to-[#0f2d1a]">
      <div className="container mx-auto px-4 text-center">
        {/* 404 Icon and Number */}
        <div className="mb-8">
          <div className="relative inline-block">
            <FontAwesomeIcon 
              icon={faExclamationTriangle} 
              className="text-8xl text-[#C2C764] mb-4 opacity-20" 
            />
            <h1 className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-6xl font-bold text-white">
              404
            </h1>
          </div>
        </div>

        {/* Error Message */}
        <div className="mb-12">
          <h2 className="text-4xl font-bold text-white mb-4">Page Not Found</h2>
          <p className="text-xl text-white/80 mb-6 max-w-2xl mx-auto leading-relaxed">
            Oops! The page you're looking for seems to have wandered off into the wilderness. 
            Don't worry, even the best explorers sometimes take a wrong turn.
          </p>
          <p className="text-lg text-white/60 max-w-xl mx-auto">
            The page might have been moved, deleted, or you might have typed the wrong URL.
          </p>
        </div>

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row justify-center gap-4 mb-12">
          <Link 
            to="/" 
            className="group inline-flex items-center justify-center bg-[#C2C764] hover:bg-[#a8b04a] text-[#2b603e] font-bold py-4 px-8 rounded-full transition-all duration-300 text-lg shadow-lg hover:shadow-xl transform hover:-translate-y-1"
          >
            <FontAwesomeIcon icon={faHome} className="mr-3" />
            Go Home
          </Link>
          <Link 
            to="/products" 
            className="group inline-flex items-center justify-center bg-white/10 hover:bg-white/20 text-white font-bold py-4 px-8 rounded-full transition-all duration-300 text-lg border-2 border-white/30 hover:border-white/50 backdrop-blur-sm"
          >
            <FontAwesomeIcon icon={faShoppingBag} className="mr-3" />
            Browse Products
          </Link>
        </div>

        {/* Quick Links */}
        <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-8 max-w-2xl mx-auto">
          <h3 className="text-2xl font-bold text-white mb-6">Quick Links</h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <Link 
              to="/about" 
              className="group flex items-center justify-center text-white/80 hover:text-white hover:bg-white/10 py-3 px-4 rounded-lg transition-all duration-300"
            >
              <FontAwesomeIcon icon={faSearch} className="mr-3" />
              About Us
            </Link>
            <Link 
              to="/contact" 
              className="group flex items-center justify-center text-white/80 hover:text-white hover:bg-white/10 py-3 px-4 rounded-lg transition-all duration-300"
            >
              <FontAwesomeIcon icon={faSearch} className="mr-3" />
              Contact
            </Link>
            <Link 
              to="/lab-tests" 
              className="group flex items-center justify-center text-white/80 hover:text-white hover:bg-white/10 py-3 px-4 rounded-lg transition-all duration-300"
            >
              <FontAwesomeIcon icon={faSearch} className="mr-3" />
              Lab Tests
            </Link>
            <Link 
              to="/auth" 
              className="group flex items-center justify-center text-white/80 hover:text-white hover:bg-white/10 py-3 px-4 rounded-lg transition-all duration-300"
            >
              <FontAwesomeIcon icon={faSearch} className="mr-3" />
              Sign In
            </Link>
          </div>
        </div>

        {/* Back Button */}
        <div className="mt-8">
          <button 
            onClick={() => window.history.back()}
            className="group inline-flex items-center text-white/60 hover:text-white transition-colors duration-300"
          >
            <FontAwesomeIcon icon={faArrowLeft} className="mr-2" />
            Go Back
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;